import { z } from "zod";

/**
 * Pronunciation score breakdown from Azure Speech Service
 */
export const PronunciationScoreSchema = z.object({
  accuracyScore: z.number().min(0).max(100),
  fluencyScore: z.number().min(0).max(100),
  completenessScore: z.number().min(0).max(100),
  pronScore: z.number().min(0).max(100),
});

export type PronunciationScore = z.infer<typeof PronunciationScoreSchema>;

/**
 * Individual message in a conversation session
 */
export const ConversationMessageSchema = z.object({
  messageId: z.string(),
  role: z.enum(["user", "assistant"]),
  text: z.string(),
  audioKey: z.string().nullish(),
  pronunciationScore: PronunciationScoreSchema.nullish(),
  timestamp: z.coerce.date(),
});

export type ConversationMessage = z.infer<typeof ConversationMessageSchema>;

/**
 * User's conversation practice record for a slide
 * Each conversation represents one complete practice session
 */
export const ConversationSchema = z.object({
  id: z.string(),
  userId: z.string(),
  slideId: z.string(),
  lessonId: z.string(),
  messages: z.array(ConversationMessageSchema),
  finalScore: z.number().min(0).max(100).nullish(),
  completedAt: z.coerce.date(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type Conversation = z.infer<typeof ConversationSchema>;
